var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "6px",
    viewBox: "0 0 20 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "95A7BCAD-C8DF-48B8-94D3-2A80D1FB35C2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Admin-Settings-List-View",
    transform: "translate(-1272.000000, -215.000000)",
    fill: "#B6B6B6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1282.37441,222.922358 C1283.62082,222.922358 1284.63124,223.932774 1284.63124,225.179186 C1284.63124,226.425597 1283.62082,227.436014 1282.37441,227.436014 C1281.128,227.436014 1280.11759,226.425597 1280.11759,225.179186 C1280.11759,223.932774 1281.128,222.922358 1282.37441,222.922358 Z M1282.37441,215.632358 C1283.62082,215.632358 1284.63124,216.642774 1284.63124,217.889186 C1284.63124,219.135597 1283.62082,220.146014 1282.37441,220.146014 C1281.128,220.146014 1280.11759,219.135597 1280.11759,217.889186 C1280.11759,216.642774 1281.128,215.632358 1282.37441,215.632358 Z M1282.37441,208.342358 C1283.62082,208.342358 1284.63124,209.352774 1284.63124,210.599186 C1284.63124,211.845597 1283.62082,212.856014 1282.37441,212.856014 C1281.128,212.856014 1280.11759,211.845597 1280.11759,210.599186 C1280.11759,209.352774 1281.128,208.342358 1282.37441,208.342358 Z",
    id: "Menu-Icon",
    transform: "translate(1282.374413, 217.889186) rotate(90.000000) translate(-1282.374413, -217.889186) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon2);
export default __webpack_public_path__ + "static/media/menuIcon2.bc8b844beeb5c552aadc652031cb242a.svg";
export { ForwardRef as ReactComponent };